//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DeleteCsvExcelAccountsService } from "@/features/accounts/csv-excel/services/delete-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";


export const useDeleteCsvExcelAccount = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const deleteCsvExcelAccountsService = new DeleteCsvExcelAccountsService();

  // CsvExcel口座削除
  const deleteCsvExcelAccounts = async (
    accountGroupId: string,
    csvExcelAccountId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await deleteCsvExcelAccountsService.deleteCsvExcelAccounts({
        account_group_id: accountGroupId,
        csvexcel_account_id: csvExcelAccountId,
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("deleteCsvExcelAccounts", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    deleteCsvExcelAccounts: errorHandledAsync(deleteCsvExcelAccounts, setError),
  };
};
